<template>
  <div>
    <div>
      <v-toolbar flat>
        <v-toolbar-title>Company Settings</v-toolbar-title
        ><v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
    </div>
    <div>
      <vue-table
        :http="table.http"
        :url="table.url"
        :headingTransformer="table.headingTransformer"
        :except="table.except"
        :html="table.html"
        :additionalColumns="table.additionalColumns"
        :additionalColumnsTransformer="table.additionalColumnsTransformer"
        :valueTransformer="table.valueTransformer"
      ></vue-table>
    </div>
  </div>
</template>
<script>
import util from "@/util/util";
import action from "./action.vue";
import vueTable from "../shared/vue-table.vue";

export default {
  components: { vueTable },
  data() {
    return {
      util,
      table: {
        http: util.http,
        url: "company-setting",
        html: ["status", "Action"],
        except: ["id", "created_at", "updated_at", "deleted_at"],
        additionalColumns: ["Action"],
        headingTransformer: function(val) {
          return util.camelCase(val);
        },
        valueTransformer: function() {
          return {
            status: (row) => {
              return [
                {
                  item:
                    '<span style="color:white;padding:0.4rem" class="badge ' +
                    (row.status == 0 ? "new badge red" : "new badge green") +
                    '">' +
                    (row.status == 0 ? "Not Active" : "Active") +
                    "</span>",
                  handler: () => null,
                },
              ];
            },
          };
        },
        additionalColumnsTransformer: function() {
          return {
            Action: (row) => {
              return [
                {
                  comp: action,
                  prop: {
                    edit: {
                      name: "CompanySettingEdit",
                      params: {
                        id: row.id,
                      },
                    },
                  },
                },
              ];
            },
          };
        },
      },
    };
  },
};
</script>
<style scoped>
a {
  text-decoration: none;
}
</style>
